module.exports = __webpack_public_path__ + "img/gplay.8ff15266.jpg";